// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"610":"d49bdece1e2623db4be3","943":"ce4fe89460ad9eb65b16"}[chunkId] + ".bundle.js";
};